import { DeliveryRisk } from 'client/../decl'

export type DeliveryOutlook =
  | { available: false }
  | {
      available: true
      deliveryPercent: number
      returnPercent: number
      tooltipLines: string[]
    }

const toDisplayPercent = (probability: number): number =>
  Math.round(probability * 100)

const hasValidProbabilities = (risk: DeliveryRisk): boolean =>
  typeof risk.p_delivery === 'number' &&
  Number.isFinite(risk.p_delivery) &&
  typeof risk.p_rto === 'number' &&
  Number.isFinite(risk.p_rto)

/** Pure presentation helper: validate + format probabilities only. */
export const getDeliveryOutlook = (
  risk: DeliveryRisk | null | undefined,
): DeliveryOutlook => {
  if (risk == null || !hasValidProbabilities(risk)) {
    return { available: false }
  }

  const deliveryPercent = toDisplayPercent(risk.p_delivery)
  const returnPercent = toDisplayPercent(risk.p_rto)

  return {
    available: true,
    deliveryPercent,
    returnPercent,
    tooltipLines: [
      'Delivery outlook',
      `${deliveryPercent}% chance of delivery`,
      `${returnPercent}% chance of return`,
    ],
  }
}
